// @ts-nocheck
import create from 'zustand'

export const useAllDomainsStore = create((set) => ({
  allDomains: [],
  setAllDomains: (allDomains) => set(() => ({allDomains: [...allDomains]})),
}))
